import { useState } from "react";
import { Footer } from "../Footer/Footer"
import { HerosectionsAll } from "../HeroSectionAll/HerosectionsAll"
import { Header } from "../IndexPage/Header/Header"

export const Contact = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contactNumber: '',
        subject: '',
        message: '',
    });

    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch('https://formspree.io/f/xzzbbvoe', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (response.ok) {
            setStatus({ success: true, message: 'Message sent Succefully!' });
            setFormData({
                name: '',
                email: '',
                contactNumber: '',
                subject: '',
                message: '',
            }); // Reset form
        } else {
            setStatus({ success: false, message: 'Error sending message.' });
        }
    };

    return (
        <>
         <div className="container-fluid">
            <div className="row " onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Contact" />
                    <HerosectionsAll ScreenName="Contact Us" ScreenSearch="Contact" />
                    {/* <Header actives="CONTRACT OF INSURANCE" />
                    <HerosectionsAll ScreenName="CONTRACT OF INSURANCE" /> */}
                    {/* <Principles /> */}
                    <div className=" row p-2 p-lg-5 mt-3 mt-lg-5 " >

                        <div className="text-center col-12 mt-3 mt-lg-0  col-lg-4 bounce" id="hover_effect">
                            <div className="faint rounded p-lg-5 p-2 shadow2 height_contact">
                                <img src="Static/Assets/Img/contacts.png" className="VisionMission_icon mb-3" alt="" /><br />
                                <span className="fw-bold green fs-5">Mobile Number</span>
                                <p className="pt-1" >
                                    <a href="tel:8218088830" className="text-dark">+91 8218 0888 30</a>
                                </p>
                            </div>
                        </div>

                        <div className="text-center mt-3 mt-lg-0 col-12 col-lg-4  bounce" id="hover_effect">

                            <div className="faint rounded p-lg-5 p-2 shadow2 height_contact">
                                <img src="Static/Assets/Img/email (1).png" className="VisionMission_icon mb-3" alt="" /><br />
                                <span className="fw-bold green  fs-5">Email Address</span>
                                <p className=" pt-1" >
                                    <a href="mailto:Amilsoteam4@gmail.com" className="text-dark">
                                        milsoconnect1@gmail.com</a>
                                </p>
                            </div>
                        </div>

                        <div className="text-center col-12 col-lg-4 bounce" id="hover_effect">
                            <div className="faint rounded p-lg-5 p-2 shadow2 height_contact" >
                                <img src="Static/Assets/Img/officeLocation.png" className="VisionMission_icon mb-3" alt="" /><br />
                                <span className="fw-bold green fs-5">Address</span>
                                <p className="pt-1" >
                                    Anuradha More and Associates,<br />
                                    204 Gurukrupa CHS,<br />
                                    Nehru Nagar, <br />
                                    Kurla (E)
                                    Mumbai 400024
                                </p>
                            </div>
                        </div>

                    </div>

                    {/* <div>
                        <div class="col-12 p-5">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.520835968536!2d73.82188887436637!3d18.460052671021643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc295e613b54b99%3A0x466d7a51d1b0faef!2scenter%20for%20development%20advance%20technologies!5e0!3m2!1sen!2sin!4v1688378218568!5m2!1sen!2sin"
                                class="map_cdat" style={{ border: '0', height: '60vh', width: '100%' }} allowfullscreen=" " loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div> */}

                    <div className="row col-lg-10 mx-auto" >

                        <div className="col-12 p-lg-5">
                            <form className="contact-form row" onSubmit={handleSubmit}>
                                <div className="form-field col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className="form-control form_controls"
                                            id="name"
                                            name="name"
                                            placeholder="Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="name" className="labels">Name</label>
                                    </div>
                                </div>
                                <div className="form-field col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className="form-control form_controls"
                                            id="email"
                                            name="email"
                                            placeholder="Email Id"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="email" className="labels">Email Id</label>
                                    </div>
                                </div>
                                <div className="form-field col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className="form-control form_controls"
                                            id="contactNumber"
                                            name="contactNumber"
                                            placeholder="Contact Number"
                                            value={formData.contactNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="contactNumber" className="labels">Contact Number</label>
                                    </div>
                                </div>
                                <div className="form-field col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className="form-control form_controls"
                                            id="subject"
                                            name="subject"
                                            placeholder="Subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="subject" className="labels">Subject</label>
                                    </div>
                                </div>
                                <div className="form-field col-lg-12">
                                    <div className="form-floating mb-3">
                                        <textarea
                                            className="form-control form_controls"
                                            id="message"
                                            name="message"
                                            placeholder="Input Message Here..."
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="message" className="labels">Input Message Here...</label>
                                    </div>
                                </div>
                                <div className="form-field col-lg-6 py-5">
                                    <button type="submit" className="btn Free_Quote w-100 fs-5">SUBMIT</button>
                                </div>
                            </form>
                            {status && <p className={status.success ? 'success' : 'error'}>{status.message}</p>}
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
}
